/*###########################################################################
// Tabs
//#########################################################################*/

import { scrollTo } from "../utilities/_scrollTo"

export default function tabs() {
	return {
		activeTab: 1,

		breakpoints: {
			desktop: 1024
		},

		init() {
			const self = this

			setTimeout(function() {
				if (self.$el.hasAttribute('data-tab-pref')) {
					const prefTab = self.$el.querySelector('.tabs__nav__item[data-tab="' + self.$el.getAttribute('data-tab-pref') + '"]')

					if (prefTab !== null) {
						const prefTabIndex = parseInt(prefTab.getAttribute('data-tab'))
						self.setActiveTab(prefTabIndex)
					} else {
						self.setActiveTab(1)
					}
 				} else {
					self.setActiveTab(1)
				}

				setTimeout(function() {
					self.$el.style.opacity = '1'
				}, 100)
			}, 250)
		},

		setActiveTab(tabIndex) {
			this.activeTab = tabIndex

			if (window.innerWidth < this.breakpoints.desktop) {
				const offsetAmount = document.querySelector('.header')?.clientHeight || 0
				scrollTo(this.$el, -offsetAmount)
			}
		},

		handleSelectChange(event) {
			if (event.target.classList.contains('input')) {
				this.activeTab = parseInt(event.target.options[event.target.selectedIndex].value)

				if (window.innerWidth < this.breakpoints.desktop) {
					const offsetAmount = document.querySelector('.header')?.clientHeight || 0
					scrollTo(this.$el, -offsetAmount)
				}
			}
		}
	}
}
